import fetch_serve from "@/config/request";

// 获取系统设置内容
export function getSiteSettings() {
  return fetch_serve({
    url: `/api/DynamicContent/settings`,
    method: 'get'
  })
}

// 更新系统设置内容
// data的传参 data = {"jsonContent": "string"}
export function updateSettings(data) {
  return fetch_serve({
    url: `/api/DynamicContent/settings`,
    method: 'put',
    data
  })
}
